import { useMemo } from 'react';

import { useContentfulContentTypeEntry } from '@order/Contentful';

import type { Asset } from 'contentful';

// ─────────────────────────────────────────────────────────────────────────────

export const usePartnerShareLineItemContent = (params: Params) => {
  const { lineItemSlug, pause } = params;

  // ─── Remote Data ─────────────────────────────────────────────────────

  const searchParams = useMemo(
    () => ({ 'fields.sharedLineItemSlug': lineItemSlug }),
    [lineItemSlug],
  );

  const { data, fetching } = useContentfulContentTypeEntry<PartnerShareLineItemFields>({
    contentType: 'partnerShareLineItem',
    searchParams,
    pause,
  });

  // ─────────────────────────────────────────────────────────────────────

  return {
    content: data?.fields,
    fetching,
    shouldDisplayCategories: data?.fields?.shouldDisplayCategories ?? false,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  lineItemSlug: string;
  pause: boolean;
};

type PartnerShareLineItemFields = {
  caloriesOverride?: number;
  caloriesOverrideText?: string;
  shouldDisplayCategories?: boolean;
  sharedLineItemSlug: string;
  partnerName: string;
  partnerImage: Asset;
  productName: string;
  secondaryImage?: Asset;
  description: string;
};
